<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import ApiServiceV1 from '@/api/adminApi/AdminApiV1'

import InputBox from '@/components/general/BaseInputBox.vue'

const formWasValidated = ref(false);
const form = ref({ email: '', fullName: '' });

const { t } = useI18n()

const responseObj = ref({
  result: '',
  msg: ''
});

const submitForm = async (event) => {
  const callbackUrl = `${import.meta.env.VITE_VUE_APP_FRONTEND_URL}/${t('subscribe-email')}`;
  event.preventDefault();
  event.stopPropagation();
  if (event.target.checkValidity() === false) {
    event.target.querySelector(':invalid:not(fieldset)').focus()
  } else {
    if (!form.value.fullName) {
      try {
      const { data } = await ApiServiceV1.post('subscriptions/subscribe', {
        email: form.value.email,
        callback_url: callbackUrl,
      });
      responseObj.value = {
        result: data.result,
        msg: data.msg
      };
    } catch (error) {
      responseObj.value = {
        result: error.response.data.result,
        msg: error.response.data.msg
      };
    }
    }
  }
  formWasValidated.value = true
}
</script>

<template>
  <div class="bg-light py-3 px-4 rounded-lg text-primary">
    <template v-if="!responseObj.result">
      <h3 class="mb-1">
        {{ t('title') }}
      </h3>
      <span class="mb-3 block">{{ t('subtitle') }}</span>
      <form
        :class="{ 'was-validated': formWasValidated }"
        novalidate
        @submit.prevent="submitForm"
      >
        <div class="rounded-pill bg-white pl-4 py-1 pr-1 flex">
          <InputBox
            v-model="form.email"
            class="mb-0 w-100"
            input-id="email"
            input-type="email"
            input-validation="email"
            input-mode="email"
            :input-label="t('email')"
            auto-complete="email"
            :required="true"
            input-classes="border-0"
            label-spacing="px-2 ml-n1"
          />
          <input
            id="fullname"
            v-model="form.fullname"
            type="text"
            class="fullname"
            name="fullname"
            autocomplete="off"
          >
          <button
            type="submit"
            class="btn btn-success rounded-circle py-1 px-2"
          >
            <i class="mi-send icon-20" />
          </button>
        </div>
      </form>
    </template>
    <template v-else>
      <h3 class="mb-1">
        {{ responseObj.msg }}
      </h3>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.fullname {
    clip: rect(0, 0, 0, 0);
    position: absolute;
}
</style>

<i18n>
  {
    "cs": {
    "email": "Váš e-mail",
    "subscribe-email": "prihlaseni-k-novinkam",
    "subtitle": "Ať vám už nic nového neuletí...",
    "title": "Odebírejte newslettery"
},
    "sk": {
    "email": "Váš e-mail",
    "subscribe-email": "prihlasenie-k-novinkam",
    "subtitle": "Nech vám už nič nové neuletí...",
    "title": "Prihlásiť sa k odberu noviniek"
},
    "pl": {
    "email": "Twój adres e-mail",
    "subscribe-email": "potwierdzenie-subskrypcji",
    "subtitle": "Nie przegap niczego nowego.",
    "title": "Subskrybuj newsletter"
},
    "hu": {
    "email": "Az Ön e-mail címe",
    "subscribe-email": "hirlevel-feliratkozas",
    "subtitle": "Ne maradj le semmi újdonságról...",
    "title": "Feliratkozás a hírlevélre"
},
    "de": {
    "email": "Deine E-Mail",
    "subscribe-email": "newsletter-anmeldung",
    "subtitle": "Verpasse keine Neuigkeiten...",
    "title": "Newsletter abonnieren"
},
    "at": {
    "email": "Deine E-Mail",
    "subscribe-email": "newsletter-anmeldung",
    "subtitle": "Verpasse keine Neuigkeiten...",
    "title": "Newsletter abonnieren"
},
    "ro": {
    "email": "Adresa dvs. de e-mail",
    "subscribe-email": "abonare-la-newsletter",
    "subtitle": "Nu ratați nimic nou...",
    "title": "Abonați-vă la newsletter"
},
    "fr": {
    "email": "Votre e-mail",
    "subscribe-email": "abonnement-newsletter",
    "subtitle": "Ne laissez plus jamais passer une nouveauté...",
    "title": "Abonnez-vous aux newsletters"
}
  }
</i18n>